import { render } from "./LanguageListComponent.vue?vue&type=template&id=0f983881"
import script from "./LanguageListComponent.vue?vue&type=script&lang=js"
export * from "./LanguageListComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/Language/LanguageListComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0f983881"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0f983881', __exports__)) {
    api.reload('0f983881', __exports__)
  }
  
  module.hot.accept("./LanguageListComponent.vue?vue&type=template&id=0f983881", () => {
    api.rerender('0f983881', render)
  })

}


export default __exports__